import React from "react";
import {
  Button,
  AlertDialogAction,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogContent,
  AlertDialogTrigger,
  AlertDialog,
  buttonVariants,
} from "@/components/ui";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { VariantProps } from "class-variance-authority";

interface RemoveButtonProps {
  alertTitle: string;
  alertDescription: string;
  deleteAction: () => void;
  disabled?: boolean;
  loading?: boolean;
  size?: "sm" | "default" | "lg";
  className?: string;
  children?: React.ReactNode;
  variant?: VariantProps<typeof buttonVariants>["variant"];
}

export const RemoveButton = ({
  alertTitle,
  alertDescription,
  deleteAction,
  disabled = false,
  loading = false,
  size = "default",
  className = "",
  children,
  variant = "outlineDestructive",
}: RemoveButtonProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant={variant}
          size={size}
          disabled={disabled}
          className={className}
        >
          <Trash2 className="h-4 w-4" />
          {children}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{alertTitle}</AlertDialogTitle>
          <AlertDialogDescription>{alertDescription}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("global.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={deleteAction} disabled={loading}>
            {loading ? t("global.loading") : t("global.yes")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
